<template>
  <div class="percentage-card-contents">
    <div class="heading__container">
      <h3>{{heading}}</h3>
    </div>
    <div class="radial__container">
      <radial-progress-bar class="centered" :progressPercentage="percentage"></radial-progress-bar>
    </div>
    <div class="count__container">
      <p class="callout-text--medium text--center font-condensed">{{count}}</p>
    </div>
  </div>
</template>

<script>
  import RadialProgressBar from '@/components/ui/RadialProgressBar/RadialProgressBar.vue';

  export default {
    name: 'percentage-card-contents',

    props: ['percentage','heading','count'],

    components: {
      RadialProgressBar
    },

    data: function () {
      return {

      }
    },

    mounted:function() {

    },

    beforeDestroy: function() {

    },

    methods: {

    },

    computed:{

    }
  }
</script>

<style lang="less" scoped>
  h3 {
    font-size: 1.8rem;
  }

  .percentage-card-contents {
    width: ~"calc(100% + 4rem)";
    height: ~"calc(100% + 4rem)";
    position: relative;
    margin: -2rem -2rem;
  }

  .heading__container {
    width: 100%;
    position: absolute;
    top: 1rem;
    left: 0;

    h3 {
      width: 100%;
      text-align: center;
    }
  }

  .radial__container {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }

  .count__container {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// PercentageCardContents.vue?3fd53242